import { render, staticRenderFns } from "./answerItem.vue?vue&type=template&id=6e642658&scoped=true"
import script from "./answerItem.vue?vue&type=script&lang=js"
export * from "./answerItem.vue?vue&type=script&lang=js"
import style0 from "./answerItem.vue?vue&type=style&index=0&id=6e642658&lang=scss&scoped=true"
import style1 from "./answerItem.vue?vue&type=style&index=1&id=6e642658&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e642658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e642658')) {
      api.createRecord('6e642658', component.options)
    } else {
      api.reload('6e642658', component.options)
    }
    module.hot.accept("./answerItem.vue?vue&type=template&id=6e642658&scoped=true", function () {
      api.rerender('6e642658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/answer/answerItem.vue"
export default component.exports